import type * as React from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { X } from 'lucide-react'
import { cn } from '../../lib/utils.ts'

export const Dialog = DialogPrimitive.Root
export const DialogTrigger = DialogPrimitive.Trigger
export const DialogClose = DialogPrimitive.Close

export function DialogContent({ className, children, ...props }: React.ComponentProps<typeof DialogPrimitive.Content>) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/45 backdrop-blur-[1px]" />
      <DialogPrimitive.Content
        className={cn(
          'fixed left-1/2 top-1/2 z-50 w-[min(30rem,calc(100vw-2rem))] -translate-x-1/2 -translate-y-1/2',
          // Vysoký dialog musí jít dorolovat: bez max-výšky uteče na nízkém
          // okně nahoru i dolů a k titulku se nedá dostat.
          'flex max-h-[calc(100dvh-2rem)] flex-col',
          'rounded-[var(--radius-xl)] border border-[var(--border)] bg-[var(--card)] shadow-xl',
          className,
        )}
        {...props}
      >
        {/* Roluje jen obsah — křížek zůstává na svém místě. */}
        <div className="overflow-y-auto p-[var(--space-6)]">{children}</div>
        <DialogPrimitive.Close
          aria-label="Zavřít"
          className="absolute right-4 top-4 rounded-[var(--radius-sm)] p-1 text-[var(--muted-foreground)] hover:bg-[var(--muted)]"
        >
          <X size={16} />
        </DialogPrimitive.Close>
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  )
}

export const DialogTitle = ({ className, ...p }: React.ComponentProps<typeof DialogPrimitive.Title>) => (
  <DialogPrimitive.Title className={cn('text-[length:var(--text-xl)] font-semibold tracking-[var(--tracking-tight)]', className)} {...p} />
)
export const DialogDescription = ({ className, ...p }: React.ComponentProps<typeof DialogPrimitive.Description>) => (
  <DialogPrimitive.Description className={cn('mt-1 text-[length:var(--text-sm)] text-[var(--muted-foreground)]', className)} {...p} />
)
